module.exports = __webpack_public_path__ + "img/product-icon5.6af4badb.png";